<ui-notification [uuid]="uuid()" [duration]="duration()" color="error">
  <ng-icon name="heroTrash" size="24" class="!block size-6" slot="icon" />
  <p class="text-sm font-medium text-on-surface dark:text-on-surface-darkmode">
    @if (selectedIds().length === 1) {
      {{ 'cockpit.documents.deleteNotification.titleSingular' | transloco }}
    } @else {
      {{
        'cockpit.documents.deleteNotification.titlePlural'
          | transloco: { count: selectedIds().length }
      }}
    }
  </p>
  <p class="mt-1 text-sm text-on-surface-subtle dark:text-on-surface-subtle-darkmode">
    @if (selectedIds().length === 1) {
      {{ 'cockpit.documents.deleteNotification.subtitleSingular' | transloco }}
    } @else {
      {{ 'cockpit.documents.deleteNotification.subtitlePlural' | transloco }}
    }
  </p>
  <div class="mt-3 flex gap-1">
    <ui-button size="small" mode="outlined" (click)="onClickReset()">
      {{ 'cockpit.documents.deleteNotification.restoreButton' | transloco }}
    </ui-button>
  </div>
</ui-notification>
